import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";
import { IPVerificationStatus } from "src/model/enum/server-ip-verification";

@Component({
    selector: "app-ip-verification-status",
    templateUrl: "./ip-verification-status.component.html",
    styleUrls: ["./ip-verification-status.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IpVerificationStatusComponent implements OnInit {
  public IPVerificationStatusEnum = IPVerificationStatus;

  @Input() status: IPVerificationStatus;
  constructor () { }

  ngOnInit() { }
}
